<template>
  <div>
    <v-toolbar flat color="white" class="mb-4">
      <v-toolbar-title>{{ $t("headings.editlabel") }}</v-toolbar-title>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <div>
            <v-spacer></v-spacer>
            <locale-select @change="fireLocaleChange" />
          </div>
          <v-card>
            <label-form :isUpdate="true" :locale="locale"></label-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import LabelForm from "./components/LabelsForm";
import Cookies from "js-cookie";

export default {
  name: "EditLabel",
  components: {
    LabelForm
  },
  data() {
    return {
      locale: Cookies.get("language")
    };
  },
  methods: {
    fireLocaleChange(value) {
      this.locale = value;
    }
  }
};
</script>

<style></style>
